import { render, staticRenderFns } from "./inventorywarning.vue?vue&type=template&id=4bcbabb1&scoped=true"
import script from "./inventorywarning.vue?vue&type=script&lang=js"
export * from "./inventorywarning.vue?vue&type=script&lang=js"
import style0 from "./inventorywarning.vue?vue&type=style&index=0&id=4bcbabb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcbabb1",
  null
  
)

export default component.exports